import Menu from '@/global/components/MenuV2'
import Grid from '@/global/components/ui/Grid'
import { InputAdornment } from '@mui/material'
import { FormField } from 'global/components/Form'
import { useCentroCustoOutletContext } from 'pages/CentroCusto'
import { useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import { mapRenderCentros } from '../../mapArvore'

export const FormCentroCusto = ({ isEdicao }: { isEdicao?: boolean }) => {
    const { data } = useCentroCustoOutletContext()

    const { watch } = useFormContext()

    const id = watch('predecessorId')
    const codigo = watch('codigo')

    const predecessor = useMemo(() => {
        if (!id) return null
        return data?.find(item => item.id === id) || null
    }, [data, id])

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <FormField
                    name="predecessorId"
                    label="Nível Superior"
                    select
                    required
                >
                    <Menu.Item value={0}>Nenhum</Menu.Item>
                    {mapRenderCentros(data).map(node => (
                        <Menu.Item
                            key={node.id}
                            value={node.id}
                            sx={{ paddingLeft: 2 + node.space * 3 }}
                        >
                            {`${node.codigo} - ${node.nomeCentroCusto}`}
                        </Menu.Item>
                    ))}
                </FormField>
            </Grid>
            <Grid item xs={4}>
                <FormField
                    name="codigo"
                    label="Código"
                    required
                    {...(!isEdicao
                        ? {
                              InputProps: {
                                  startAdornment: (
                                      <InputAdornment position="start">
                                          <span
                                              title={
                                                  predecessor?.codigo + codigo
                                              }
                                              className="opacity-50"
                                          >
                                              {predecessor?.codigo}
                                          </span>
                                      </InputAdornment>
                                  ),
                              },
                              placeholder: '_ _ _ _ _ _',
                              options: {
                                  blocks: [6],
                              },
                          }
                        : {})}
                />
            </Grid>
            <Grid item xs={8}>
                <FormField name="nomeCentroCusto" label="Nome" required />
            </Grid>
            <FormField name="empresaId" hidden />
        </Grid>
    )
}
